import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from "../config/analyticsTrack";
import "./GHT.css"
import Logo from './assets/logo.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Header from './components/Header';
import Footer from './Footer';
import QRCode from "react-qr-code";

export default function GhtQRCode(props) {

    useEffect(() => {
        analyticsUserTrack("GHT - GHT QR Code", "Landing");
        window.scrollTo(0, 0);
    }, [])

    

    return <div className='version-2 GHT nairobi-june'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/GHT"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                <Header page="social-impact" />
            </div>
        </div>
        <div style={{ marginTop: 80 }}></div>
        <div className='container py-5'>
            <QRCode style={{ height: "calc(100vh - 150px)", width: "100%"}} value={"https://teqbahn.com/GHT"} />
        </div>
        <Footer />
    </div>
}
